import * as Yup from "yup";
import { OperatorCommisionFeePaymentTypes, OperatorCommisionFeeValueTypes } from "../../interfaces/endpoints/trips/Trips.types";

const commissionFeeSchema = Yup.object().nullable().shape({
  fee: Yup
    .number()
    .transform((value) => {
      if (isNaN(value)) return undefined;
      // Convert the input percentage to decimal for backend
      return parseFloat(value) / 100;
    })
    .test("is-valid-percentage", "Komisioni duhet të jetë midis 0% dhe 100%", (value) => {
      if (!value && value !== 0) return true;
      return value >= 0 && value <= 1;
    })
    .nullable(),
  paymentType: Yup
    .number()
    .oneOf(Object.values(OperatorCommisionFeePaymentTypes).filter((x) => typeof x === "number") as number[])
    .default(OperatorCommisionFeePaymentTypes.JourneyReservation),
  valueType: Yup
    .number()
    .oneOf(Object.values(OperatorCommisionFeeValueTypes).filter((x) => typeof x === "number") as number[])
    .default(OperatorCommisionFeeValueTypes.Percentage)
});

const TripsSchema = Yup.object().shape({
  // operationalInterval: Yup.object().test({
  //   name: "at-least-one-day-selected",
  //   message: "Zgjedh ditën/ditët e udhëtimit për orarin",
  //   test: (value) => {
  //     const days = [
  //       "monday",
  //       "tuesday",
  //       "wednesday",
  //       "thursday",
  //       "friday",
  //       "saturday",
  //       "sunday"
  //     ];
  //     return days.some((day) => value[day] === true);
  //   }
  // }),
  trip: Yup.object().shape({
    lineId: Yup.number()
      .typeError("Vendos linjën e orarit")
      .required("Vendos linjën e orarit"),
    departureTimeString: Yup.string().required("Vendos kohën e nisjes"),
    arrivalTimeString: Yup.string().required("Vendos kohën e arritjes"),
    isReservable: Yup.boolean().test(
      "Valuta",
      "Valuta duhet të jetë euro per te qene e rezervushme",
      (isReservable, ctx) => {
        if (isReservable && ctx.parent.defaultCurrencyId === 2) {
          return false;
        }
        return true;
      }
    )
  }),
  schedules: Yup.array().of(
    Yup.object().shape({
      stationId: Yup.number()
        .typeError("Vendos linjën e orarit")
        .required("Vendos stacionin e ndalesës"),
      // departureTime: Yup.string().test(
      //   "Vendos kohën e nisjes nga stacioni",
      //   "Koha duhet të jetë më e madhe se koha e nisjes së linjës",
      //   (departureTime: any, ctx: any) => {
      //     if (departureTime) {
      //       return departureTime > ctx.parent.departureTime;
      //     }
      //     return false;
      //   }
      // )

      departureTimeString: Yup.string()
        .typeError("sheno dicka")
        .required("Vendos kohën e nisjes")
    })
  ),
  entityCommissionFee: commissionFeeSchema
});

export default TripsSchema;
